/*
 * @Author: bbqin
 * @Date: 2022-01-11 14:45:03
 * @LastEditTime: 2022-07-08 11:31:35
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\CardContainer\output.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import * as API from "./compatible";
import CardContainer from "./index";

/**
 * @param {string} mainCode 
 * @param {object} config 
 */

export default function compatible() {
    this.register("cardContainer");
    return {
        store: CardContainer.useCardContainer,
        ...apiBindPage.call(this, API),
    };
}

function apiBindPage(API) {
    let res = {};
    for (let pop of Object.keys(API)) {
        res[pop] = API[pop].bind(this);
    }
    return res;
}

compatible.component = CardContainer;
compatible.displayName = "CardContainer";
compatible.unfinished = [];